module.exports = __webpack_public_path__ + "static/media/flowers_6.2b62f3e3.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_6.csv
// module id = 763
// module chunks = 0